import { _post } from "@/utils/request.js";
const preApi = process.env.NODE_ENV !== "production" ? "/api" : process.env.VUE_APP_API;
const URL = {
  blogRewriter: preApi + "/ai/blog_rewriter",
  blogRewriterTask: preApi + '/task/task/blog_rewriter'
};

const getBlogRewriter = async (data) => _post(URL.blogRewriter, data);
const getBlogRewriterProgress = async (data) => _post(URL.blogRewriterTask, data);
export { getBlogRewriter, getBlogRewriterProgress };